import {
  FETCH_CASES,
  FETCH_CASES_SUCCESS,
  CHANGE_CASE_LIST_PAGE,
  CHANGE_CASE_LIST_PAGE_SIZE,
  FETCH_CASES_FAIL,
  UPDATE_CASE_LIST_FILTERS,
  SELECT_CASES_ID,
  SELECT_CASES,
  RELOAD_CASES,
  ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE
} from '../../actions/cm/caseList';
import {
  FETCH_TYPOLOGIES_SUCCESS,
  FETCH_SOURCES_SUCCESS
} from '../../actions/cm/alertList';
import {
  CHANGE_ALERT_STATUS,
  CHANGE_ALERT_ASSIGN_TO_USER
} from '../../actions/cm/alertDetails';
import { CREATE_CASE_SUCCESS } from '../../actions/cm/caseCreation';
import { CASE_ACTION_SUBMIT } from '../../actions/cm/caseAction';
import { FETCH_DEPARTMENTS_SUCCESS } from '../../actions/cm/departments';
import { CREATE_CASE_FROM_ALERT_SUCCESS } from '../../actions/cm/convertAlertsToCase';
import {
  DEFAULT_DATE_RANGE_DAYS,
  DEFAULT_PAGE_SIZE
} from '../../../pages/constants/cmConstants';
import { fromDaysToRangeBack } from '../../../pages/cm/utils/common';
import { MERGE_ALERTS_TO_CASE_SUCCESS } from '../../actions/cm/mergeAlertsToCase';

import { head } from '../../../util/lodashlike';
const { from, to } = fromDaysToRangeBack(DEFAULT_DATE_RANGE_DAYS);

export const initialState = {
  list: [],
  isLoading: false,
  hasLoaded: false,
  total: 0,
  hasError: false,
  currentPage: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  filters: {
    department: null,
    assignedUser: [],
    status: null,
    alertLevel: null,
    from,
    to,
    searchField: '',
    searchText: '',
    typologyIds: [],
    approvalStatus: '',
    sourceIds: []
  },
  selectedIds: [],
  selectedCases: [],
  errorMessage: null,
  typologies: [],
  sources: [],
  // FIN-13485: who the persisted `filters` belong to. Stamped and validated by the persist
  // layer (redux/persist/caseListPersistConfig.js), never by this reducer.
  filtersOwner: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_CASES:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_CASES_SUCCESS:
      return {
        ...state,
        list: payload.cases,
        total: payload.total,
        isLoading: false,
        hasLoaded: true
      };
    case FETCH_CASES_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case CHANGE_CASE_LIST_PAGE:
      // FIN-10962: Preserve selection across page changes so Assign keeps
      // working on cross-page selections. Bulk Update is disabled at the UI
      // level when selection spans pages (see CaseListActions.js).
      return {
        ...state,
        currentPage: payload,
        hasLoaded: false
      };
    case CHANGE_CASE_LIST_PAGE_SIZE:
      return {
        ...state,
        pageSize: payload,
        selectedIds: [],
        selectedCases: [],
        hasLoaded: false
      };
    case FETCH_DEPARTMENTS_SUCCESS: {
      // FIN-13485: departments are re-fetched on every Case Listing mount, which used to
      // overwrite the selected department with the first one — defeating the persisted
      // filters on reload. Keep the current department while it is still one of the
      // user's departments; only fall back to the first when none is set or it is gone.
      const current = state.filters.department;
      const stillValid =
        current != null && (payload || []).some((dept) => dept?.id === current);
      return {
        ...state,
        filters: {
          ...state.filters,
          department: stillValid ? current : head(payload)?.id
        }
      };
    }
    case UPDATE_CASE_LIST_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...payload },
        hasLoaded: false,
        currentPage: 1,
        selectedIds: [],
        selectCases: []
      };
    case SELECT_CASES_ID:
      return { ...state, selectedIds: payload };
    case SELECT_CASES:
      return { ...state, selectedCases: payload };
    case RELOAD_CASES:
    case CASE_ACTION_SUBMIT:
    case ASSIGN_CASE_ACTION_INFO_MODAL_CLOSE:
    case CREATE_CASE_FROM_ALERT_SUCCESS:
    case MERGE_ALERTS_TO_CASE_SUCCESS:
    case CREATE_CASE_SUCCESS:
      return {
        ...state,
        hasLoaded: false,
        selectedIds: payload?.keepSelection ? state.selectedIds : []
      };
    case CHANGE_ALERT_STATUS:
    case CHANGE_ALERT_ASSIGN_TO_USER:
      return { ...state, hasLoaded: false };
    case FETCH_TYPOLOGIES_SUCCESS:
      return {
        ...state,
        typologies: payload
      };
    case FETCH_SOURCES_SUCCESS:
      return {
        ...state,
        sources: payload
      };

    default:
      return state;
  }
}
